import { Box } from "@mui/material";
import { Fragment } from "react";
import Text from "@/components/Text";
import { TitleDetail } from "./assessment-constant";
import FreeTextQuestionCard from "./FreeTextQuestionCard";
import {
  FreeTextAudience,
  FreeTextScreenerDef,
  FreeTextValues,
  QuestionValue,
  ScreenerQuestion,
} from "./assessment-types";
import { isVisible, questionsFor } from "./free-text-screening";

interface FreeTextScreeningFormProps {
  def: FreeTextScreenerDef;
  questions: ScreenerQuestion[];
  values: FreeTextValues;
  onChange: (questionUuid: string, value: QuestionValue) => void;
  audience?: FreeTextAudience;
  titleDetail?: TitleDetail;
  disabled?: boolean;
}

const FreeTextScreeningForm = ({
  def,
  questions,
  values,
  onChange,
  audience,
  titleDetail,
  disabled,
}: FreeTextScreeningFormProps) => {
  const byId: Record<number, string[]> = {};
  questionsFor(def, questions).forEach(({ question, q }) => {
    byId[q.questionId] = values[question.uuid!]?.answers ?? [];
  });
  const visible = questionsFor(def, questions, audience).filter(({ q }) =>
    isVisible(q, byId)
  );

  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      {titleDetail?.title && <Text fontWeight="bold">{titleDetail.title}</Text>}
      {visible.map(({ question, q }, index) => {
        const uuid = question.uuid!;
        const isNewGroup = !!q.group && q.group !== visible[index - 1]?.q.group;
        return (
          <Fragment key={uuid}>
            {isNewGroup && (
              <Text
                size={12}
                fontWeight="bold"
                c="text.secondary"
                sx={{ textTransform: "uppercase", mt: index ? 1 : 0 }}
              >
                {q.group}
              </Text>
            )}
            <FreeTextQuestionCard
              q={q}
              title={q.label ?? question.question}
              value={values[uuid] ?? { answers: [], notes: "" }}
              disabled={disabled}
              onChange={(next) => onChange(uuid, next)}
            />
          </Fragment>
        );
      })}
    </Box>
  );
};

export default FreeTextScreeningForm;
